module.exports = __webpack_public_path__ + "img/Carte-apaym-05.2d491428.png";